var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"components__editor"},[_c('div',{attrs:{"id":_vm.editorId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }